import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import React, { useState } from "react"
import { FlatList, RefreshControl, ScrollView, Text, TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import CustomTopicItem from "./CustomTopicItem/CustomTopicItem"
import styles from "./styles"
import { Button } from "@Components/CustomButton/Button"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import EmptyDiscussions from "@Components/CustomTopicContent/EmptyDiscussions"

const CustomForumTopic = (props) => {
    const { navigation, topics, toggleCreateForumModal, title, handleFetchForums, fetching } = props
    const [selectedId, setSelectedId] = useState(null)
    const renderItem = ({ item }) => (
        <CustomTopicItem item={item} navigation={navigation} setSelectedId={setSelectedId} topicCategory={title} />
    )

    const header = () => (
        <OpenSansText style={styles.title} defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(18)}>
            Sujet {title}
        </OpenSansText>
    )

    const footer = () => (
        <Button
            onPress={toggleCreateForumModal}
            text="Créer un sujet"
            width="70%"
            height={RFValue(50)}
            backgroundColor={baseColors.green.primary}
            labelColor={"white"}
        />
    )

    return (
        <View style={styles.container}>
            <FlatList
                data={topics}
                ListHeaderComponent={header}
                ListFooterComponent={footer}
                showsVerticalScrollIndicator={false}
                ListEmptyComponent={<EmptyDiscussions label={"Aucun Forum disponible."} />}
                renderItem={renderItem}
                keyExtractor={(item) => item.id.toString()}
                extraData={selectedId}
                contentContainerStyle={styles.contentContainer}
                refreshControl={<RefreshControl refreshing={fetching} onRefresh={handleFetchForums} />}
            />
        </View>
    )
}

export default CustomForumTopic
